import { setPageErrorInfo } from './digitalDataBuilder';

export const buildBaseEventData = (primaryCategory, eventName) => {
  const baseObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
  };

  return baseObject;
};

export const buildCategoryData = (omnitureInfo) => ({
  primaryCategory: omnitureInfo.primaryCategory,
  subCategory1: omnitureInfo.subCategory1,
  subCategory2: omnitureInfo.subCategory2 || omnitureInfo.subCategory1,
});

export const buildErrorAnalyticsEvent = (errorObject, primaryCategory, eventName) => {
  if (!primaryCategory) {
    setPageErrorInfo(errorObject);
    return null;
  }
  const errorAnalyticObject = {
    category: { primaryCategory },
    eventInfo: {
      eventName,
      error: [{
        ...errorObject,
      }],
    },
  };
  return errorAnalyticObject;
};
